<div class="knowledge-status" *ngIf="loading">
  <ion-spinner name="crescent"></ion-spinner>
  <span>{{ loadingMessage }}</span>
</div>

<div class="knowledge-buttons" *ngIf="status">
  <button class="knowledge-button" type="button"
    [ngClass]="status.has_technical_docs ? 'knowledge-button--ok' : 'knowledge-button--warn'"
    (click)="navigate.emit()">
    <ion-icon name="document-text-outline" class="knowledge-button__icon"></ion-icon>
    <span class="knowledge-button__label">{{ technicalDocsLabel }}</span>
    <ion-icon [name]="status.has_technical_docs ? 'checkmark-circle' : 'close-circle'" class="knowledge-button__status"></ion-icon>
  </button>
  <button class="knowledge-button" type="button"
    [ngClass]="status.has_db_scripts ? 'knowledge-button--ok' : 'knowledge-button--warn'"
    (click)="navigate.emit()">
    <ion-icon name="server-outline" class="knowledge-button__icon"></ion-icon>
    <span class="knowledge-button__label">{{ dbScriptsLabel }}</span>
    <ion-icon [name]="status.has_db_scripts ? 'checkmark-circle' : 'close-circle'" class="knowledge-button__status"></ion-icon>
  </button>
</div>

<div class="knowledge-status-inline" *ngIf="error">
  <span class="status-badge status-badge--warn">
    <ion-icon name="alert-circle-outline"></ion-icon>
    {{ errorMessage }}
  </span>
</div>

<ng-content></ng-content>
